module.exports = __webpack_public_path__ + "img/1-4.c9755970.svg";